import { Location, NavigateFunction } from "react-router-dom"
import { Scroling } from "../../utilities/functions"
import { ViewModel } from "../../utilities/ViewModelStructure"
import { mainPath } from "../../Constants/MainPath"

export class NavigatorVM extends ViewModel{
    private navigator:NavigateFunction = (a)=>{}
    private locator:()=>string =()=>''
    public location :Location<any>|null=null

    public  HomePage = ()=>this.navigateTo('/home') 
    public  AboutPage = ()=>this.navigateTo('/about') 
    public  BlogPage = ()=>this.navigateTo('/blog')
    public  ContactPage = ()=>this.navigateTo('/contact') 
    public  ResumePage = ()=>this.navigateTo('/resume') 
    public  Certificats = ()=>this.navigateTo('/certificats') 
    public  TeamPage = ()=>this.navigateTo('/team') 
    public  Services = ()=>this.navigateTo('/services') 
    public  Artical = (id:string)=> this.navigateTo('/artical?id='+id) 
    public  FQA = ()=> this.navigateTo('/FQA') 

    public setNavigator(value:NavigateFunction){
        this.navigator = value;
    }

    public setLocator(value:()=>string ){
        this.locator = value;
    }
    public setLocation(value:Location<any>){
        this.location = value
    }

    public removeQueryParameter (key:string){
        const searchParams = new URLSearchParams(this.location?.search);
        searchParams.delete(key)
        this.navigator({
            pathname: this.location?.pathname,
            search: searchParams.toString()
          }, { replace: true });
    }

    public updateQueryParam (key:string , value:string) {
        const searchParams = new URLSearchParams(this.location?.search);
        searchParams.set(key, value);
        this.navigator({
          pathname: this.location?.pathname,
          search: searchParams.toString()
        }, { replace: true });
    }

    private navigateTo (path:string){
        if(this.navigator)this.navigator(mainPath+path);
    }


    public getLocation():string{
        return this.locator()
    }
}